import { render, staticRenderFns } from "./SelectDepartment.vue?vue&type=template&id=10e3fac4&"
import script from "./SelectDepartment.vue?vue&type=script&lang=js&"
export * from "./SelectDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports